import iresaErrorStatus from "@/state/iresaErrorStatus"
import { navigateToError } from "@/router/navigate"
import { stopLoadingAll } from "@/composables/useLoading"
import { BookingQuotePrestation, BookingStatusEnum } from "../../../../requests-module"
import Tracking from "@/tracking"
import getQueryParams from "@/utils/getQueryParams"
import { processPrestations } from "@/logic/options/bookingQuote"

const handleIresaError = async (err: any, isRedirectToError = true, isThrowError = true) => {
    console.log('isRedirectToError: ', isRedirectToError)
    console.error(' err.response?.data?.message? ', err.response?.data?.message)
    if (
        err.response?.data?.message?.includes("Iresa status: Partial") ||
        err.response?.data?.message?.includes("n'est pas disponible") ||
        err.response?.data?.message?.includes("Le Nombre de jours avant") ||
        err.response?.data?.message?.includes("booking is cancelled")
    ) {
        iresaErrorStatus.value = BookingStatusEnum.UNAVAILABLE
        try {
            // TRACKING
            const queryParams: {
                [key: string]: string;
            } = getQueryParams()
            const prestations: BookingQuotePrestation[] = processPrestations(queryParams.prestations)
            Tracking.trackProductUnavailable(
                queryParams.lihe_id,
                queryParams.start_date,
                queryParams.end_date,
                prestations,
                queryParams.season
            )
        } catch (err) {
            console.error(err)
        }
    } else {
        iresaErrorStatus.value = BookingStatusEnum.ERROR
        console.error(err)
    }
    stopLoadingAll()
    if (isRedirectToError) navigateToError()
    if (isThrowError) throw err
    return err
}

export default handleIresaError